import { useState, useEffect } from "react"

//Diese Hook speichert Eingabeformularwerte im sessionStorage und stellt sie beim Laden wieder her im SESSION STORAGE
//T-> Generic, weil verschiedene Eingabefelder verschiedene Values haben können
// -> Daten sind nicht mehr da wenn man den Tab schließt
export default function useFormPersistence<T extends Record<string, any>>(key: string, initialValues: T) {
  const [values, setValues] = useState<T>(() => {
    //Beim ersten Laden: gespeicherte Werte abrufen, falls vorhanden
    //lädt die gespeicherten Formulardaten (oder null, wenn keine da sind)
    const saved = sessionStorage.getItem(key) 

    //Wenn es gespeicherte Werte gibt, nutze die sonst nutze die Standardwerte
    if (saved) {
      //wandelt den gespeicherten Text wieder in ein Objekt um
      const parsed = JSON.parse(saved) 
      //als ein Objekt wiedergeben mit Spread operator, alles aus initial Values und alles aus parsed
      //das zweite Objekt überschreibt Werte vom ersten bei Dopplungen
      return { ...initialValues, ...parsed } 
    } else {
      //wenn nichts gespeichert war, startet es mit leeren Standardwerten
      return initialValues 
    }
  })

  //useEffect für alle key value paare - speichern bei jeder Änderung des Formulars
  useEffect(() => {
    sessionStorage.setItem(key, JSON.stringify(values)) 
  }, [key, values]) 

  //Methode um die jetzigen gespeicherten Werte wieder zu vergessen
  const clearForm = () => {
    sessionStorage.removeItem(key)
  }

  //Für die Formulare in onChange
  const handleChange = (field: keyof T, value: any) => {
    //kopiert alle bisherigen Werte (prev) und überschreibt nur das geänderte Feld
    //field = Name des Feldes, value = neuer Wert
    setValues((prev) => ({ ...prev, [field]: value })) 
  }

  return { values, setValues, handleChange, clearForm } 
}
